import React from 'react';
import { Box } from '@mui/material';
import { useAppSelector } from '../../../../../app/store';
import { useGetFeeSchedulesByContractIdQuery } from '../../../../../services/ContractService';
import FeeScheduleGrid from '../../grids/contractGrids/FeeScheduleGrid';
import { AddEditFeeScheduleDialog } from '../../dialogs/contractDialogs';

const DrgTab: React.FC = () => {
  const contract = useAppSelector((state) => state.contract.currentContract);
  
  // Query to get all fee schedules for this contract
  const { data: allFeeSchedules, isLoading, error } = useGetFeeSchedulesByContractIdQuery(
    { contractId: contract?.id || '' },
    { skip: !contract?.id }
  );

  // Filter for DRG fee schedules only
  const drgFeeSchedules = allFeeSchedules?.filter(fs => fs.feeType === 'DRG') || [];

  return (
    <Box>
      <FeeScheduleGrid
        title="DRG Fee Schedules"
        feeSchedules={drgFeeSchedules}
        isLoading={isLoading}
        error={error}
        contractId={contract?.id}
        company={contract?.company}
        actions={<AddEditFeeScheduleDialog feeType="DRG" />}
      />
    </Box>
  );
};

export default DrgTab;
